// @flow

import React, { Component, useState, useEffect, useCallback } from 'react';
import Portal from '../../../common/Portal';
import t from '../../../i18n/I18n';
import SearchUtil from '../../../util/SearchUtil';
import KeyboardShortcuts from '../../../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../../../keyboard-shortcuts/KeydownConfig';
import { KeyCode } from '../../../util/Constants';
import TextWithEllipsis, { TextWithEllipsisFileExtension } from '../../../common/TextWithEllipsis';
import MetadataUtil from '../../../util/MetadataUtil';
import './AutoCompleteComponent.css';
import Button from '../../Button';
import ToolTip from '../../AssetPropertyView';
const debug = require('../../../debug/debug')('wc:advanced-search:AutoComplate');

type Props = {
  value: any,
  onChange: Function,
  metadataKeyName: string,
  itemsLength: number,
  tagName: string,
  className: string,
  isClearButton: boolean,
  fromComponent: string
};

export default class AutoCompleteComponent extends React.Component<Props, {}> {
  state = {
    value: this.props.value
  };
  componentDidMount() {
    const node = document.querySelector(`[name="${this.props.metadataKeyName}"]`);
    this.props.fromComponent == 'TimeDataPoint' && node ? node.focus() : null;
  }

  onChange = (data: string) => {
    // this.setState({value:data});
    this.props.onChange(data);
  };
  onClick = () => {
    const node = document.querySelector(`[name="${this.props.metadataKeyName}"]`);
    node.value = '';
    node.focus();
  };

  render() {
    return (
      <div name="AutoComplateComponet">
        <AutoCompleteBox
          searchValue={this.props.value}
          onSearchValueChange={this.onChange}
          onKeyUp={this.props.onKeyUp}
          index={this.props.index}
          metadataKey={this.props.metadataKeyName}
          itemsLength={this.props.itemsLength}
          tagName={this.props.tagName}
          className={this.props.className}
          onClick={this.onClick}
          isClearButton={this.props.isClearButton}
          fromComponent={this.props.fromComponent}
          onParentEnterClick={this.props.onParentEnterClick}
        />
      </div>
    );
  }
}

type AutoCompleteTextBoxProps = {
  value: ?string,
  onSearchValueChange: (e: React.ChangeEvent) => void,
  onBlur: Function,
  name: ?string,
  isDisabled: boolean,
  tagName: ?string,
  className: ?string,
  onClick: Function,
  isClearButton: boolean,
  fromComponent: string
};
const AutoCompleteTextBox = function(props: AutoCompleteTextBoxProps) {
  const name = props.tagName ? props.tagName : null;
  const popClass = props.className ? props.className : null;
  return (
    <div style={{ width: '100%' }} name={name} className={popClass}>
      <ToolTip text={props.value}>
        <input
          name={props.name}
          value={props.value}
          onChange={props.onSearchValueChange}
          onBlur={props.onBlur}
          onKeyUp={(e) => {
            if (props.onKeyUp) props.onKeyUp(e, props.index);
          }}
          //autoComplete={false}
          disabled={props.isDisabled}
          style={{textOverflow: 'ellipsis'}}
          className="form-control form-control-sm-2"
          placeholder={!props.fromComponent ? t('Any') : ''}
          type="text"
          autoComplete="off"
          //onFocus={props.onclick}
        />
      </ToolTip>
      
      {props.isClearButton ? <Button icon="images/cross_gray.svg" onClick={props.onClick} /> : null}
    </div>
  );
};

type AutoCompleteBoxProps = {
  searchValue: ?string,
  onSeachValueChange: (newValue: ?string) => void,
  metadataKey: ?string,
  itemsLength: number,
  tagName: ?string,
  className: ?string,
  onClick: Function,
  isClearButton: boolean,
  fromComponent: string,
  onParentEnterClick: function
};

const AutoCompleteBox = function(props: AutoCompleteBoxProps) {
  const [searchValue: ?string, setSearchValue: (s: ?string) => void] = useState(props.searchValue);
  const [textBoxFocused: boolean, setTextBoxFocused: (textBoxFocused: boolean) => void] = useState(false);
  const [propValue: boolean, setpropValue: (textBoxFocused: boolean) => void] = useState(false);
  const metadataKey: ?string = props.metadataKey;
  const [itemsLength: number, setItemsLength: (n: number) => void] = useState(props.itemsLength);

  if (props.searchValue && !propValue) {
    setSearchValue(props.searchValue);
    setpropValue(true);
  }

  if (props.itemsLength != itemsLength) {
    setItemsLength(props.itemsLength);
    setSearchValue(props.searchValue);
  }

  const isDisabled = MetadataUtil.DISABLED_METADATA_LIST_ADVANCE.includes(metadataKey) ? true : false;
  const onSearchValueChange = useCallback(
    (newSearchValue: ?string) => {
      props.fromComponent ? props.onSearchValueChange(newSearchValue) : '';
      setSearchValue(() => {
        if (textBoxFocused === false) {
          setTextBoxFocused(true);
        }
        return newSearchValue;
      });
    },
    [searchValue, textBoxFocused]
  );
  return (
    <div>
      <div style={{ display: 'flex', position: 'relative' }}>
        <AutoCompleteTextBox
          value={searchValue}
          name={metadataKey}
          index={props.index}
          onKeyUp={props.onKeyUp}
          onBlur={() => {
            textBoxFocused === true && setTextBoxFocused(false);
            props.onSearchValueChange(searchValue);
          }}
          onSearchValueChange={(e) => onSearchValueChange(e.target ? e.target.value : '')}
          isDisabled={isDisabled}
          tagName={props.tagName}
          isClearButton={props.isClearButton}
          className={props.className}
          fromComponent={props.fromComponent}
          onClick={() => {
            setSearchValue('');
            props.onClick();
          }}
        />
        {textBoxFocused === true ? (
          <RenderAutoSearchList
            searchValue={searchValue}
            setSelectedValue={(selectedValue) => {
              setSearchValue(selectedValue);
              props.onSearchValueChange(selectedValue);
              setTextBoxFocused(false);
              if (props.onParentEnterClick && props.fromComponent != 'TimeDataPoint') props.onParentEnterClick();
            }}
            metadataKey={metadataKey}
            onTextBoxEnter={(searchValue) => {
              setTextBoxFocused(false);
              props.onSearchValueChange(searchValue);
              if (props.onParentEnterClick) props.onParentEnterClick();
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

type RenderAutoSearchListProps = {
  searchValue: ?string,
  setSelectedValue: (selectedValue: string) => void,
  metadataKey: ?string,
  onTextBoxEnter: Function
};

const runSearchQuary = _.debounce((props, setAutocompleteResult, mounted) => {
  const autoSearch: Promise<FilesResponseData> = SearchUtil.autoCompleteSearch(
    props.metadataKey,
    props.searchValue,
    (fields) => {
      if (mounted) {
        if (fields && _.size(fields) > 0) {
          setAutocompleteResult(fields);
        } else {
          setAutocompleteResult(null);
        }
      }
    }
  );
}, 350);

const RenderAutoSearchList = function(props: RenderAutoSearchListProps) {
  const [autocompleteResult: ?Array<any>, setAutocompleteResult: (result: ?Array<any>) => void] = useState(null);
  //Do not change the order ot use state and useEffect.
  useEffect(() => {
    let mounted: boolean = true;
    if (props.searchValue) {
      runSearchQuary(props, setAutocompleteResult, mounted);
    } else {
      setAutocompleteResult(null);
    }
    return () => {
      mounted = false;
    };
  }, [props.searchValue]);

  const [selectedIndex: number, setSelectedIndex: (result: number) => void] = useState(-1);

  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      setSelectedIndex((previousIndex) => {
        let newSelectedIndex = previousIndex;
        const count = _.size(autocompleteResult);
        if (e.keyCode === KeyCode.UP) {
          if (debug.enabled) debug('[RenderAutoSearchList.onKeyUp()] %s', e.keyCode);
          newSelectedIndex = newSelectedIndex - 1;
          if (newSelectedIndex < 0) {
            newSelectedIndex = count - 1;
          }
        } else if (e.keyCode === KeyCode.DOWN) {
          if (debug.enabled) debug('[RenderAutoSearchList.onKeyDown()] %s', e.keyCode);
          newSelectedIndex = newSelectedIndex + 1;
          if (newSelectedIndex >= count) {
            newSelectedIndex = 0;
          }
        } else if (e.keyCode === KeyCode.ENTER) {
          if (debug.enabled) debug('[RenderAutoSearchList.onKeyEnter()] %s', e.keyCode);
          if (previousIndex >= 0 && autocompleteResult && autocompleteResult.length > previousIndex) {
            props.setSelectedValue(autocompleteResult[previousIndex]);
          } else {
            props.onTextBoxEnter(e.target.value);
          }
        }
        return newSelectedIndex;
      });
    },
    [autocompleteResult]
  );

  useEffect(() => {
    if (debug.enabled) debug('[RenderAutoSearchList] mounted');
    KeyboardShortcuts.remove('ADVANCED_SEARCH_FILE_NAME_AUTO_COMPLETE');
    KeyboardShortcuts.add(
      new KeydownConfig(
        'ADVANCED_SEARCH_FILE_NAME_AUTO_COMPLETE',
        onKeyDown,
        [KeyCode.UP, KeyCode.DOWN, KeyCode.ENTER],
        [],
        false
      )
    );
    return () => {
      if (debug.enabled) debug('[RenderAutoSearchList] un-mounted');
      KeyboardShortcuts.remove('ADVANCED_SEARCH_FILE_NAME_AUTO_COMPLETE');
    };
  }, [onKeyDown, autocompleteResult]);

  if (autocompleteResult) {
    return (
      <div className="autoCompleteList" style={{ overflow: 'hidden' }}>
        {autocompleteResult.map((value, index) => {
          return (
            <dd
              className={selectedIndex === index ? 'selected' : ''}
              key={index}
              onMouseDown={(e) => props.setSelectedValue(value)}>
              <TextWithEllipsisFileExtension title={value} style={{ fontSize: '12px' }} text={value} />
            </dd>
          );
        })}
      </div>
    );
  }
  return null;
};
